/**
 * Settings row "Easing favourites and recent curves" (W2-05; `ext.easing.favourites` / `ext.easing.recents`): shows
 * the kept curves and clears either list.
 */

import type { AppServices } from '../../app/registry/types';
import { Button, CurveThumb } from '../../ui';
import { m } from './easing.messages';
import s from './Easing.module.css';
import { useSettings, useText } from './hooks';
import { easeKey, easeList, FAVOURITES_KEY, RECENTS_KEY } from './pickerModel';

export function FavouritesSetting(props: { readonly services: AppServices }) {
  const { t } = useText();
  const settings = useSettings(props.services);
  const favourites = easeList(settings.ext[FAVOURITES_KEY]);
  const recents = easeList(settings.ext[RECENTS_KEY]);
  return (
    <div className={s.chips}>
      <span className={s.muted}>
        {t(m.favouritesCount, { favourites: favourites.length, recents: recents.length })}
      </span>
      {favourites.map((e) => (
        <CurveThumb key={easeKey(e)} ease={e} size={24} animate={false} />
      ))}
      <Button
        size="sm"
        variant="ghost"
        disabledReason={favourites.length === 0 ? { key: m.noFavourites } : null}
        onClick={() => {
          props.services.settings.setExt(FAVOURITES_KEY, []);
        }}
      >
        {t(m.clearFavourites)}
      </Button>
      <Button
        size="sm"
        variant="ghost"
        disabledReason={recents.length === 0 ? { key: m.recentsCleared } : null}
        onClick={() => {
          props.services.settings.setExt(RECENTS_KEY, []);
        }}
      >
        {t(m.clearRecents)}
      </Button>
    </div>
  );
}
